import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const ModalWarningChangeSchooling = (props) => { 
  const [t] = useTranslation(["global", "class"]);
  
  
  return (
    <Modal
      show={props.show}
      bsSize="large"
      aria-labelledby="contained-modal-title-lg" 
    >
      <Modal.Header>
        <Modal.Title className="modal-title">
          {t("class:modalChangeSchooling.titleGradeGroup")}
        </Modal.Title> 
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col md={12} className="mb-2">
            {t("class:modalChangeSchooling.descriptionGradeGroup")}
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-secondary"
          onClick={() => props.onClose(false)}
        >
          {t("global:buttons.cancel")}
        </Button>
        <Button onClick={()=>props.changeSchoolingConfirmed() }>{t("global:buttons.accept")}</Button>
      </Modal.Footer>
    </Modal>
  );
};

ModalWarningChangeSchooling.propTypes = {
  show: PropTypes.bool, //Required
  onClose: PropTypes.func, //Required
  changeSchoolingConfirmed: PropTypes.func, //Required
};

export default ModalWarningChangeSchooling; 
